// extracted by mini-css-extract-plugin
export default {"inCharge":"CmbB4gRwy6IeDtMnUXL0W"};